export default function UrgencyBanner() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-8 lg:px-12 bg-accent-500 relative overflow-hidden">
      {/* Decorative shapes */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-1/4 w-40 h-40 rounded-full bg-background-50 blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-60 h-60 rounded-full bg-background-50 blur-3xl" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center reveal">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 border border-background-50/20 backdrop-blur-sm mb-5">
          <span className="relative flex h-2.5 w-2.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-background-50 opacity-75" />
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-background-50" />
          </span>
          <span className="text-background-50 text-sm font-semibold">
            Hable con nuestros especialistas
          </span>
        </div>

        <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-background-50 mb-4 leading-tight">
          ¿Tienes un proyecto de climatización?
        </h2>
        <p className="text-background-200 text-base md:text-lg max-w-2xl mx-auto mb-6 leading-relaxed">
          Analizamos las necesidades de su empresa y desarrollamos soluciones eficientes en{" "}
          <strong className="text-background-50">climatización, refrigeración y ventilación mecánica</strong>,{" "}
          adaptadas a las características de cada proyecto.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
          <a
            href="https://wa.me/573232209100"
            target="_blank"
            rel="noopener noreferrer"
            className="px-7 py-3.5 rounded-lg bg-accent-600 text-background-50 font-semibold text-base hover:bg-accent-700 transition-colors border border-accent-400/40 whitespace-nowrap"
          >
            <i className="ri-whatsapp-line mr-2" />
            Consultar por WhatsApp
          </a>
        </div>

        <p className="text-background-300 text-xs mt-4">
          Climatización · Refrigeración · Ventilación mecánica
        </p>
      </div>
    </section>
  );
}